/* Shipping-province picker in the cart (snippets/cart-province-select.liquid).

   Duty lines follow localStorage 'userProvince' (ExciseTax in assets/cart.js). Changing
   the province here recalculates duty in place. Unlike the header picker it does NOT
   empty the cart or send the shopper to the home page.

   The drawer footer is re-rendered after every cart change, so this is a custom
   element: each fresh copy reads the saved province in connectedCallback. */
if (!customElements.get('cart-province-select')) {
  customElements.define(
    'cart-province-select',
    class CartProvinceSelect extends HTMLElement {
      connectedCallback() {
        this.select = this.querySelector('select');
        if (!this.select) return;

        const saved = localStorage.getItem('userProvince');
        if (saved && this.select.querySelector(`option[value="${CSS.escape(saved)}"]`)) {
          this.select.value = saved;
        }

        this.onChange = this.onChange.bind(this);
        this.select.addEventListener('change', this.onChange);
      }

      disconnectedCallback() {
        if (this.select) this.select.removeEventListener('change', this.onChange);
      }

      async onChange() {
        const province = this.select.value;
        if (!province) return;

        localStorage.setItem('userProvince', province);

        // Keep the header pickers in step. Setting .value does not fire their change
        // handler, which would empty the cart.
        document.querySelectorAll('.provinceSelector').forEach((el) => {
          if (el !== this.select) el.value = province;
        });

        this.select.disabled = true;
        if (typeof disableCheckoutButton === 'function') disableCheckoutButton();

        try {
          if (!window.ExciseTax) throw new Error('ExciseTax is not loaded');
          const result = await window.ExciseTax.reconcile();

          // Re-renders the drawer items and footer (CartItems.onCartUpdate) so the
          // duty rows and totals show the new province.
          if (result && result.changed && typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
            publish(PUB_SUB_EVENTS.cartUpdate, { source: 'excise-reconcile' });
          }
        } catch (error) {
          console.error('[cart-province] duty update failed', error);
        } finally {
          this.select.disabled = false;
          if (typeof enableCheckoutButton === 'function') enableCheckoutButton();
        }
      }
    }
  );
}
